'use strict';

var baseCore = require('integrations/product/base');
var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();

function handlePostCartAdd(response) {
    // conditional added for response, sometimes it was failing when called on page load
    if (response) {
        $('.minicart').trigger('count:update', response);
        var messageType = response.error ? 'alert-danger' : 'alert-success';
        // show add to cart toast
        if (response.newBonusDiscountLineItem
            && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
            this.chooseBonusProducts(response.newBonusDiscountLineItem);
        } else if (messageType === 'alert-danger') {
            if ($('.add-to-cart-messages').length === 0) {
                $('body').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }

            $('.add-to-cart-messages').append(
                '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                + response.message
                + '</div>'
            );

            setTimeout(function () {
                $('.add-to-basket-alert').remove();
            }, 5000);
        }
    }
}
function createSlider(images, assets, $productContainer) {
    var $sliderContainers = $productContainer.find('.slider-container');
    var data = images !== null ? {images} : null;
    data.assets = assets || null;

    // Reversing order in which to update sliders so that thumbnails get initialized first
    $($sliderContainers.get().reverse()).each((index, sliderContainer) => {
        if (! $(sliderContainer).hasClass('complete-the-look')) {
            var $slider = $(sliderContainer).find('.slider');
            $slider.trigger('slider:update', data);
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    if (attr.displayValue) {
        $productContainer.find('[data-attr="' + attr.id + '"]').find('.non-color-display-value, .color-display-value')
            .text(attr.displayValue);
    }

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');

        var $swatchButton = $attrValue.parent('button');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $attrValue.attr('selected', 'selected');
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
            $attrValue.removeAttr('selected');
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable available unavailable out-of-stock');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        $attrValue.addClass(attrValue.available ? 'available' :  toggleObject.viewOutOfStockItems ? 'out-of-stock' : 'unavailable');

        $attrValue.attr('value', attrValue.url).removeAttr('disabled');
        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}
function updateBISNFormPID(pid) {
    var BISNForm = document.getElementById("backInStockForm");
    if (BISNForm) {
        var productId = BISNForm.querySelector('input[name="productId"]');
        productId.value = pid;
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                baseCore.methods.handleVariantResponse(data, $productContainer);
                baseCore.methods.updateOptions(data.product.optionsHtml, $productContainer);
                baseCore.methods.updateQuantities(data.product.quantities, $productContainer);
                updateBISNFormPID(data.product.id);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

baseCore.methods.handlePostCartAdd = handlePostCartAdd;
baseCore.methods.createSlider = createSlider;
baseCore.methods.processSwatchValues = processSwatchValues;
baseCore.methods.attributeSelect = attributeSelect;

baseCore.nonColorAttribute = function () {
    var scope = this;

    $(document).on('click', 'button.swatch:not(.color-attribute)', function (e) {
        e.preventDefault();

        $('body').trigger('product:swatchClicked', [$(this), toggleObject]); // add trigger for any attribute click use (incl. nonClickable Attrs)
        if (scope.methods.checkForClickableAttribute($(this)) && !toggleObject.viewOutOfStockItems) {
            return;
        }

        if ($('.product-bundle').length) {
            var $productContainer = $('.bundle-main-product').length ? $(this).closest('.bundle-main-product') : $(this).closest('.product-bundle');
        } else {
            var $productContainer = $(this).closest('.set-item');
        }

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }

        scope.methods.attributeSelect($(this).attr('data-url'), $productContainer);

        $(this).closest('.non-color-attribute-swatches').find('.non-color-display-value').text($(this).find('.swatch-value').data('display-value'))
            .removeClass('text--brand-tertiary')
            .addClass('text--brand-secondary');
    });
};

//Attributes that display as color swatches
baseCore.colorAttribute = function () {
    var scope = this;

    $(document).on('click', '[data-attr="color"] button', function (e) {
        e.preventDefault();

        $('body').trigger('product:swatchClicked', [$(this), toggleObject]); // add trigger for any attribute click use (incl. nonClickable Attrs)
        if (scope.methods.checkForClickableAttribute($(this)) && !toggleObject.viewOutOfStockItems) {
            return;
        }

        if ($('.product-bundle').length) {
            var $productContainer = $('.bundle-main-product').length ? $(this).closest('.bundle-main-product') : $(this).closest('.product-bundle');
        } else {
            var $productContainer = $(this).closest('.set-item');
        }

        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        scope.methods.attributeSelect($(this).attr('data-url'), $productContainer);

        $productContainer.find('.color-display-value').text($(this).find('.swatch').data('displayvalue'))
            .removeClass('text--brand-tertiary')
            .addClass('text--brand-secondary');
    });
};

baseCore.handleLogoSelection = function () {
    // Handle logo selection
    $('body').on('click', 'button.logo', function(e) {
        var logo = $(e.currentTarget);
        var logoContainer = logo.closest('.logos');
        logoContainer.find('button.logo').removeClass('selected');
        logo.addClass('selected');

        // Remove any former signs of an error
        logoContainer.find('.logos .error-text').addClass('d-none');
        logoContainer.find('.logo-container').removeClass('error');
    });

    // Disable Logo selection when 'none' logo placement option is selected
    $('body').on('change', '.product-options', function (e) {
        var $logoOption = $(e.currentTarget).find('[data-option-id="logo"]')[0];
        var $selectedOption = $(e.currentTarget).find(':selected');
        var optionID = $selectedOption.data('valueId');

        // check if the option that was changed is a logo option and if it is 'none'
        if ($logoOption.contains($selectedOption[0]) && optionID === 'none') {
            $(e.currentTarget).find('button.logo').prop('disabled', true);
            $(e.currentTarget).find('button.logo').removeClass('selected');

            // Remove any former signs of an error
            $(e.currentTarget).find('.logos .error-text').addClass('d-none');
            $(e.currentTarget).find('.logo-container').removeClass('error');
        } else {
            $(e.currentTarget).find('button.logo').removeAttr('disabled');
        }
    });

    // Disable logo selection when option is reset after other attribute selection
    $('body').on('product:afterAttributeSelect', function (e, response) {
        var logoOption = $('[data-option-id="logo"] select');
        if (logoOption.length > 0) {
            logoOption.each(index => {
                var logoContainer = $(this).closest('logos');
                var selectedLogoOption = $(this).find(':selected')[0];
                var optionID = selectedLogoOption.dataset.valueId;
                if (optionID === 'none') {
                    logoContainer.find('button.logo').prop('disabled', 'true');
                    logoContainer.find('button.logo').removeClass('selected');
                }
            });
        }
    });
};

/**********
* shared across QV and PDP
*/
baseCore.addToCart = function () {
   var scope = this;

   // if qty stepper input has focus, we need to blur it so product data can update before button click
   $(document).on('mouseenter', 'button.add-to-cart, button.add-to-cart-global', function (event) {
       var $button = $(event.target);
       var $container = $button.closest('.product-detail');
       if (!$container.length) {
           $container = $button.closest('.quick-view-dialog');
       }
       var $qtyStepperInput = $container.find('.quantity-stepper input');

       if ($qtyStepperInput.length && $qtyStepperInput.is(':focus')) {
           $qtyStepperInput.blur();
       }
   });

   $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (event) {
        // Remove any former signs of an error
        $('.logos .error-text').addClass('d-none');
        $('.logo-container').removeClass('error');
        $('.name-tag-error-text').addClass('d-none');
        $('.name-tag-container').removeClass('error');

        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;
        var quantity;
        // Check for and add selected logo to cart
        var $productContainer = $(this).closest('.product-detail').length > 0 ? $(this).closest('.product-detail') : $(this).closest('.quick-view-dialog').find('.product-detail');
        var selectedLogoID = $('.product-logos .logo.selected').data('logo-id') ? $('.product-logos .logo.selected').data('logo-id') : '';
        var options = scope.methods.getOptions($productContainer);
        var logoOption = JSON.parse(options).find(opt => opt.optionId = 'logo');

        var masterPID = $productContainer[0].dataset.pid;

        // Get name tag information
        var nameTag = $(".name-tag[data-pid=\'" + masterPID +  "\']").length ? $(".name-tag[data-pid=\'" + masterPID +  "\']").val() : '';
        var nameTagRegex = new RegExp($(".name-tag[data-pid=\'" + masterPID +  "\']").attr("pattern"));

       // Display error and don't allow customer to add to cart if they have logo placement selected without a logo selected
       if (logoOption && logoOption.selectedValueId !== 'none' && selectedLogoID === '') {
            $('.logos .error-text').removeClass('d-none');
            $('.logo-container').addClass('error');
            document.querySelector('.logo-container').scrollIntoView({ behavior: "smooth", block: "center"});
        }
        // Display error and don't allow customer to add to cart if the name tag field contains input that is not alphanumberic
        else if (nameTag.length && !nameTagRegex.test(nameTag)) {
            $('.name-tag-error-text').removeClass('d-none');
            $('.name-tag-container').addClass('error');
            document.querySelector('.name-tag-container').scrollIntoView({ behavior: "smooth", block: "center"});
        }
        // Else allow add to cart to occur normally
        else {
            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                var $products = $(this).closest('.product-detail').find('.product-set-item-detail');
                if (!$products.length) {
                    if ($(this).closest('.quick-view-dialog').length) {
                        $products = $(this).closest('.quick-view-dialog').find('.product-set-item-detail');
                    } else {
                        $products = $('.product-detail');  // pagedesigner component 'Add all to cart btn' won't have .product-set-item-detail classes
                    }
                }

                let setSelectedLogoIDs = [];
                let setNameTags = [];
                $products.each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        var setItemPID = $(this).find('.product-id').text()
                        setPids.push({
                            pid: setItemPID,
                            qty: $(this).find('.quantity-select').val(),
                            options: scope.methods.getOptions($(this)),
                        });

                        setNameTags.push({
                            pid: setItemPID,
                            nameTag: $(this).find('input.name-tag').length ? $(this).find('input.name-tag').val() : ''
                        });

                        setSelectedLogoIDs.push({
                            pid: setItemPID,
                            selectedLogoID: $(this).find('.product-logos .logo.selected').data('logo-id') ? $(this).find('.product-logos .logo.selected').data('logo-id') : ''
                        })
                    }
                });

                nameTag = JSON.stringify(setNameTags);
                selectedLogoID = JSON.stringify(setSelectedLogoIDs);
                pidsObj = JSON.stringify(setPids);
            }

            pid = scope.methods.getPidValue($(this));

            quantity = $(this).hasClass('single-variant-quick-add-to-cart') ? 1 : scope.methods.getQuantitySelected($(this));

            $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                if ($(this).hasClass('single-variant-quick-add-to-cart')) {
                    addToCartUrl = $(this).data('url');
                } else {
                    $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                    var $productModalbody = $(this).closest('.modal-content');
                    addToCartUrl = scope.methods.getAddToCartUrl($productModalbody);
                }
            } else {
                addToCartUrl = scope.methods.getAddToCartUrl($productContainer);
            }

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: scope.methods.getChildProducts(),
                quantity: quantity,
                options: scope.methods.getOptions($productContainer),
                selectedLogoID: selectedLogoID,
                nameTag: nameTag
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        scope.methods.handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $('body').trigger('product:afterAddToCartQuickview', data); //cart page quickview only
                        $.spinner().stop();
                        scope.methods.miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        }
   });
},
module.exports = baseCore;
